import { getValidToken } from "../../../utils/authUtils";
import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_API_HOST}project-module/project-users`;

export const projectUserService = {
  getProjectUsers: async (projectId: string) => {
    try {
      const token = await getValidToken();
      const response = await axios.get(`${BASE_URL}/${projectId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.isSuccess) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching project users:", error);
      return [];
    }
  },

  getAllProjectUsers: async (companyId: string) => {
    try {
      const token = await getValidToken();
      const response = await axios.get(
        `${BASE_URL}/${companyId}/all-project-users`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.isSuccess) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching project users:", error);
      return [];
    }
  },

  addUserToProject: async (projectId: string, userData: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.post(`${BASE_URL}/${projectId}`, userData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.isSuccess) {
        return response.data.data;
      }
      // Handle case where isSuccess is false but no exception was thrown
      if (response.data.message) {
        throw new Error(response.data.message);
      }
      return [];
    } catch (error: any) {
      console.error("Error adding user to project:", error);
      // Extract error message from axios error response
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      // If it's already an Error object, re-throw it
      if (error instanceof Error) {
        throw error;
      }
      // Fallback error message
      throw new Error("Failed to add user to project");
    }
  },

  updateProjectUser: async (projectId: string, userData: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.put(
        `${BASE_URL}/${projectId}/${userData.id}`,
        userData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.isSuccess) {
        return response.data.data;
      }
      // Handle case where isSuccess is false but no exception was thrown
      if (response.data.error) {
        throw new Error(response.data.error);
      }
      return [];
    } catch (error: any) {
      console.error("Error updating project user:", error);
      // Extract error message from axios error response
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      // If it's already an Error object, re-throw it
      if (error instanceof Error) {
        throw error;
      }
      // Fallback error message
      throw new Error("Failed to update project user");
    }
  },

  removeUserFromProject: async (projectId: string, userId: string) => {
    try {
      const token = await getValidToken();
      const response = await axios.delete(
        `${BASE_URL}/${projectId}/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.isSuccess) {
        return response.data.data;
      }
      // Handle case where isSuccess is false but no exception was thrown
      if (response.data.error) {
        throw new Error(response.data.error);
      }
      return [];
    } catch (error: any) {
      console.error("Error removing user from project:", error);
      // Extract error message from axios error response
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      // If it's already an Error object, re-throw it
      if (error instanceof Error) {
        throw error;
      }
      // Fallback error message
      throw new Error("Failed to remove user from project");
    }
  },

  getCompanyUsers: async (companyId: string) => {
    try {
      const token = await getValidToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}users/company/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.isSuccess) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching project users:", error);
      return [];
    }
  },
  getUsersFromOtherProjects: async (companyId: string, projectId: string) => {
    try {
      const token = await getValidToken();
      const response = await axios.get(
        `${BASE_URL}/${projectId}/${companyId}/users-from-other-projects`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.isSuccess) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching project users:", error);
      return [];
    }
  },

  addExistingUserToProject: async (projectId: string, data: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.post(
        `${BASE_URL}/${projectId}/add-existing-user`,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.isSuccess) {
        return response.data.data;
      }
      // Handle case where isSuccess is false but no exception was thrown
      if (response.data.error) {
        throw new Error(response.data.error);
      }
      return [];
    } catch (error: any) {
      console.error("Error adding user:", error);
      // Extract error message from axios error response
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      // If it's already an Error object, re-throw it
      if (error instanceof Error) {
        throw error;
      }
      // Fallback error message
      throw new Error("Failed to add existing user to project");
    }
  },
};
